import { network } from 'services/network';

export const downloadCsvFile = (params) => {
    const url = `api/bo/downloadCsvFile?fileName=${params.fileName}`;

    return network.get(url).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${params.downloadName}.csv`;
        a.click();

        return true;
    });
};
